import {useDispatch} from 'react-redux';

import {useSubscribeToNotificationsQuery} from '@dms/api/appsync';
import {omneticApi} from '@dms/api/base';
import {notificationTypes, useIsCommunicationReadStateEnabled} from '@dms/shared';

import {useDebouncedCallback} from 'shared/web';

const REFRESH_DEBOUNCE_MS = 500;

/**
 * Keeps the unread counts and the thread in sync with read state changes made elsewhere.
 *
 * The backend pushes `communication-unread_changed` to the owners and to the user who changed the
 * read state. The push is only a doorbell: the counts and the thread are read back from their
 * endpoints. MUST be mounted for the whole session, which is why the Layout calls it and not the
 * sidebar (the sidebar unmounts on mobile navigation).
 */
export function useRefreshCommunicationUnreadState() {
  const dispatch = useDispatch();
  const isReadStateEnabled = useIsCommunicationReadStateEnabled();

  // Debounced because one bulk change pushes one notification per affected message.
  const refreshUnreadState = useDebouncedCallback(() => {
    dispatch(omneticApi.util.invalidateTags(['CommunicationUnreadCount', 'CustomerMessage']));
  }, REFRESH_DEBOUNCE_MS);

  useSubscribeToNotificationsQuery((notification) => {
    if (
      !isReadStateEnabled ||
      notification.type !== notificationTypes.COMMUNICATION_UNREAD_CHANGED
    ) {
      return;
    }

    refreshUnreadState();
  });
}
